import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';



export default function Step7() {

  return (
    <>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendant" fullWidth label="DEFENDANT" />
        </Grid>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantcompany" fullWidth label="Company" />
        </Grid>
      </Grid>


      <Grid container spacing={3}>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantaddress" fullWidth label="Address" />
        </Grid>
        <Grid item  xs={12}  sm={2}>
            <TextField
            id="defendantcity"
            fullWidth
            label="City"
            />
        </Grid>
        <Grid item  xs={12} sm={2}>
            <TextField id="defendantzip" fullWidth label="Zip" />
        </Grid>
        <Grid item  xs={12} sm={2}>
            <TextField id="defendantphone" fullWidth label="Phone" />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={12}>
            <TextField id="defendantsupervisor" fullWidth label="Supervisor" />
        </Grid>

      </Grid>


      

      


</>
    
  );

}
